<template>
	<div class="userAccountSettings">

		<div class="tabBlock">
			<div>
				<v-tabs
						class="tabList"
						v-model="tab"
						center-active
						height="40"
						show-arrows

				>
					<v-tabs-slider></v-tabs-slider>
					<v-tab
							v-for="item in getTabList"
							:disabled="item.disabled"
							:key="item.tab"
							:href="item.href"
							class="tab"
							:class="{'errorTab': item.error}"
					>
						<div v-if="item.icon" class="icon"><svg-sprite :icon-id="item.icon" width="20" height="20"></svg-sprite></div>
						<div class="text">{{ item.text }}</div>
					</v-tab>
				</v-tabs>
				<v-tabs-items v-model="tab">
					<v-tab-item value="tabSchedule">
						<tab-schedule></tab-schedule>
					</v-tab-item>

					<v-tab-item value="tabHolidays">
						<tab-holidays></tab-holidays>
					</v-tab-item>

					<v-tab-item value="tabOffice">
						<tab-office></tab-office>
					</v-tab-item>

					<v-tab-item value="tabInventory">
						<tab-inventory></tab-inventory>
					</v-tab-item>

					<v-tab-item value="tabContactsTypes">
						<tab-contacts-types></tab-contacts-types>
					</v-tab-item>

					<v-tab-item value="tabDocumentsTypes">
						<tab-documents-types></tab-documents-types>
					</v-tab-item>

					<v-tab-item value="tabDepartments">
						<tab-departments></tab-departments>
					</v-tab-item>

					<v-tab-item value="tabPositions">
						<tab-positions></tab-positions>
					</v-tab-item>

					<v-tab-item value="tabCompanys">
						<tab-companies></tab-companies>
					</v-tab-item>

					<v-tab-item value="tabVersions">
						<tab-versions></tab-versions>
					</v-tab-item>

					<v-tab-item value="tabNotifications">
						<tab-notifications></tab-notifications>
					</v-tab-item>
				</v-tabs-items>
			</div>
		</div>

	</div>
</template>

<script>
import TabSchedule from "@/components/Settings/UserAccountSettings/tabs/tabSchedule.vue";
import TabHolidays from "@/components/Settings/UserAccountSettings/tabs/tabHolidays.vue";
import TabOffice from "@/components/Settings/UserAccountSettings/tabs/tabOffice.vue";
import TabInventory from "@/components/Settings/UserAccountSettings/tabs/tabInventory.vue";
import TabContactsTypes from "@/components/Settings/UserAccountSettings/tabs/tabContactsTypes.vue";
import TabDocumentsTypes from "@/components/Settings/UserAccountSettings/tabs/tabDocumentsTypes.vue";
import TabDepartments from "@/components/Settings/UserAccountSettings/tabs/tabDepartments.vue";
import TabPositions from "@/components/Settings/UserAccountSettings/tabs/tabPositions.vue";
import TabCompanies from "@/components/Settings/UserAccountSettings/tabs/tabCompanies.vue";
import TabVersions from "@/components/Settings/UserAccountSettings/tabs/tabVersions.vue";
import { mapGetters } from "vuex";
import { PERMISSIONS } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";
import TabNotifications from "@/components/Settings/UserAccountSettings/tabs/tabNotifications.vue";

export default {
	name: "UserAccountSettings",
	components: {
		TabNotifications,
		TabVersions,
		TabCompanies,
		TabDocumentsTypes,
		TabContactsTypes,
		TabOffice,
		TabSchedule,
		TabHolidays,
		TabInventory,
		TabDepartments,
		TabPositions,
	},
	computed: {
		...mapGetters([
			'permissions',
			'permissionsDefault',
		]),
		getTabList() {

			const list = this.permissionsDefault;

			return [
				{
					text: 'Schedule',
					tab: 'Schedule',
					href: '#tabSchedule',
					icon: 'calendar1',
					disabled: !getPermissionsMod({ list, path: [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_SCHEDULE ] }),
				},
				{
					text: 'Holidays',
					tab: 'Holidays',
					href: '#tabHolidays',
					icon: 'sun',
					disabled: !getPermissionsMod({ list, path: [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_HOLIDAYS ] }),
				},
				{
					text: 'Office',
					tab: 'Office',
					href: '#tabOffice',
					icon: 'mapPin',
					disabled: !getPermissionsMod({ list, path: [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_OFFICE ] }),
				},
				{
					text: 'Inventory',
					tab: 'Inventory',
					href: '#tabInventory',
					icon: 'icon-Inventory',
					disabled: !getPermissionsMod({ list, path: [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_INVENTORY ] }),
				},
				{
					text: 'Contacts types',
					tab: 'ContactsTypes',
					href: '#tabContactsTypes',
					icon: 'Phone',
					disabled: !getPermissionsMod({ list, path: [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_CONTACTS ] }),
				},
				{
					text: 'Types of documents',
					tab: 'DocumentsTypes',
					href: '#tabDocumentsTypes',
					icon: 'icon-copy',
					disabled: !getPermissionsMod({ list, path: [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_DOCUMENTS ] }),
				},
				{
					text: 'Departments',
					tab: 'Departments',
					href: '#tabDepartments',
					icon: 'department',
					disabled: !getPermissionsMod({ list, path: [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_DEPARTMENTS ] }),
				},
				{
					text: 'Positions',
					tab: 'Positions',
					href: '#tabPositions',
					icon: 'directory',
					disabled: !getPermissionsMod({ list, path: [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_POSITIONS ] }),
				},
				{
					text: 'Company',
					tab: 'Company',
					href: '#tabCompanys',
					icon: 'icon-company',
					disabled: !getPermissionsMod({ list, path: [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_COMPANY ] }),
				},
				{
					text: 'Versions',
					tab: 'Versions',
					href: '#tabVersions',
					icon: 'icon-version',
					disabled: false,
				},
				{
					text: 'Notifications',
					tab: 'Notifications',
					href: '#tabNotifications',
					icon: 'icon-notifications',
					disabled: false,
				},
			];
		},
	},
	data: () => ({
		tab: 'Schedule',
	}),
	methods: {

	},

};
</script>
<!--info/schedule-->
<style lang="scss" scoped>
@import "userAccountSettings";
</style>
